module.exports = __webpack_public_path__ + "static/media/1015_HPS_Bloc-link.6bf9e0bc.png";